import * as types from '../MutationTypes'

const state = {
  user: {},
  userChecked: false
}

const getters = {
  isAuth: state => !!(state.user && state.user.token)
}

const actions = {
  login ({ commit, state }, result) {
    localStorage.setItem('token', result.token)
    commit(types.LOG_IN, result)
  },
  logout ({ commit, state }) {
    localStorage.removeItem('token')
    commit(types.LOG_OUT)
  },
  userCheck ({ commit }) {
    commit(types.CHECK_AUTH)
  },
  updateLogin ({ commit, state }, login) {
    commit(types.UPDATE_LOGIN, login)
  }
}

const mutations = {
  [types.LOG_IN] (state, result) {
    state.user = result
  },
  [types.LOG_OUT] (state) {
    state.user = {}
  },
  [types.CHECK_AUTH] (state) {
    state.userChecked = true
  },
  [types.UPDATE_LOGIN] (state, login) {
    state.user.login = login
  }
  // [types.ADD_TO_CART] (state, { id }) {
  //   state.lastCheckout = null
  //   const record = state.added.find(p => p.id === id)
  //   if (!record) {
  //     state.added.push({
  //       id,
  //       quantity: 1
  //     })
  //   } else {
  //     record.quantity++
  //   }
  // },
  //
  // [types.CHECKOUT_REQUEST] (state) {
  //   // clear cart
  //   state.added = []
  //   state.checkoutStatus = null
  // },
  //
  // [types.CHECKOUT_SUCCESS] (state) {
  //   state.checkoutStatus = 'successful'
  // },
  //
  // [types.CHECKOUT_FAILURE] (state, { savedCartItems }) {
  //   // rollback to the cart saved before sending the request
  //   state.added = savedCartItems
  //   state.checkoutStatus = 'failed'
  // }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/Auth.js